export const times = [
  "",
  "8:00",
  "9:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
];

export const dayToStr = {
  0: "su",
  1: "mo",
  2: "tu",
  3: "we",
  4: "th",
  5: "fr",
  6: "sa",
};

export const days = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const missingPrograms = {
  NT: "Non-Credit Tisch School of the Arts",
  GH: "NYU Abu Dhabi - Graduate",
  CD: "College of Dentistry Continuing Education",
  DN: "College of Dentistry - Graduate",
};
